import React, { memo } from 'react'
import { isEmpty } from 'lodash-es'
// @ts-expect-error — importing js
import { pickRandomColor } from '../../utils'

import './DefaultAvatarComponent.scss'

const initials = (rawIdentifier = '') => {
  const identifier = (rawIdentifier?.toString() || '')
    .trim()
    .toLocaleUpperCase()

  if (isEmpty(identifier)) {
    return ''
  }

  if (identifier.length === 1) {
    return identifier[0]
  }

  const firstLast = identifier.split(/[\s]+/)

  if (firstLast.length > 1) {
    return `${firstLast[0][0]}${firstLast[1][0]}`
  }

  return `${identifier[0]}${identifier[1]}`
}

interface DefaultAvatarComponentProps {
  identifier: string
  width: number | string
  height: number | string
}

const DefaultAvatarComponent = ({
  identifier,
  width = 40,
  height = 40,
}: DefaultAvatarComponentProps) => {
  return (
    <div
      className="default-avatar-component"
      style={{
        backgroundColor: pickRandomColor(identifier),
        width,
        height,
      }}
    >
      {initials(identifier)}
    </div>
  )
}

export { initials }
export default memo(DefaultAvatarComponent)
